import {
  collection,
  limit,
  getDocs,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";
import { MemoryItem } from "../../components/MemoryWall";
import { db } from "../firebase";

const PAGE_SIZE = 25;

export const fetchMemories = async (lastDoc?: any) => {
  const memoriesRef = collection(db, "memories");

  const baseQuery = [
    where("private", "==", false),
    orderBy("date", "desc"),
    limit(PAGE_SIZE),
  ];

  const q = lastDoc
    ? query(memoriesRef, ...baseQuery, startAfter(lastDoc))
    : query(memoriesRef, ...baseQuery);

  const snapshot = await getDocs(q);

  const data = snapshot.docs.map((doc) => {
    const rawData = doc.data() as MemoryItem;
    return {
      ...rawData,
      id: doc.id,
    };
  });

  return {
    data,
    lastDoc: snapshot.docs[snapshot.docs.length - 1] || null,
    hasMore: snapshot.docs.length > 0,
  };
};
